export const SET_EDIT_ORDER_DETAILS = '@app/orderEdit/SET_EDIT_ORDER_DETAILS';
export const CLEAR_EDIT_ORDER_DETAILS = '@app/orderEdit/CLEAR_EDIT_ORDER_DETAILS';
export const CLEAR_EDIT_ORDER_DETAILS_AND_OTP = '@app/orderEdit/CLEAR_EDIT_ORDER_DETAILS_AND_OTP';
